import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class SavePageViewHitTrackingUseCase extends UseCase {
  constructor({config, pageViewHitTrackingVOFactory, savePageViewHitTrackingService}) {
    super()
    this._config = config
    this._pageViewHitTrackingVOFactory = pageViewHitTrackingVOFactory
    this._savePageViewHitTrackingService = savePageViewHitTrackingService
  }
  /**
   * @method
   * @return {Promise}
   */

  @tracer({metric: 'SavePageViewHitTrackingUseCase#execute'})
  @inlineError
  execute({adId} = {}) {
    const pageViewHitTrackingVO = this._pageViewHitTrackingVOFactory({
      adId
    })

    return this._savePageViewHitTrackingService.execute(pageViewHitTrackingVO).then(([error]) => {
      if (error) return Promise.reject(error)
      return Promise.resolve()
    })
  }
}
